import Box from '@material-ui/core/Box';
import React, {Component} from 'react';
import { withRouter } from 'react-router';
import { withUser } from '../../../utils/ReactWrappers';

import ProjectList from '../../lists/ProjectList';
import Loader from '../../widgets/Loader';

class ClientProjects extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
        const {isLoading} = this.state;

		if(isLoading) {
            return <Loader />;
        }

        return (
			<Box>
                {this.renderProjects()}
            </Box>
		);
	}

    renderProjects() {
        const {client} = this.props;

        return <ProjectList clientId={client._id} />;
    }
}

export default withRouter(withUser(ClientProjects));
